<p-toast></p-toast>

<section class="projects-screen">
    <header class="projects-header">
        <h2 class="projects-title">Projects</h2>
        <div class="projects-header-actions">
            <p-select
                [options]="businessUnitOptions"
                [(ngModel)]="selectedBusinessUnitId"
                optionLabel="displayName"
                optionValue="id"
                appendTo="body"
                class="business-unit-filter"
                (onChange)="onBusinessUnitFilterChange()">
            </p-select>
            <div class="switch-tabs">
                <button
                    type="button"
                    [class.active]="activeTab === 'my'"
                    (click)="setActiveTab('my')">
                    My Projects
                </button>
                @if (canSeeAllProjects) {
                <button
                    type="button"
                    [class.active]="activeTab === 'all'"
                    (click)="setActiveTab('all')">
                    All Projects
                </button>
                }
                @if (canSeeArchivedProjects) {
                <button
                    type="button"
                    [class.active]="activeTab === 'archived'"
                    (click)="setActiveTab('archived')">
                    Archived Projects
                </button>
                }
            </div>
            @if (canCreateProject) {
                <button class="new-project-btn" type="button" (click)="showProjectDialog(0)">
                    <i class="ri-add-line"></i>
                    <span>New Project</span>
                </button>
            }
        </div>
    </header>

    <div class="projects-grid">
        @if (activeTab === 'my') {
            @if (filteredMyProjects.length > 0) {
                @for (item of filteredMyProjects; track item.projectId) {
                    <article
                        class="project-card"
                        [ngClass]="getProjectStatusLineClass(item)"
                        [title]="getProjectStatusIndicatorLabel(item)"
                        (click)="navigateToProject(item)">
                        <div class="project-card-top">
                            <div class="project-card-title">
                                <h2>{{ item.projectName }}</h2>
                            </div>
                            <div class="project-card-actions">
                                @if (canShowProjectActionMenu(item)) {
                                    <button
                                        type="button"
                                        class="card-menu-btn"
                                        (click)="item.projectId && openProjectMenu($event, item.projectId)">
                                        <i class="ri-more-2-line"></i>
                                    </button>
                                }
                            </div>
                        </div>
                        <div class="project-card-body">
                            <p class="project-ids">EQ#{{ item.projectNumber }} &bull; CX#{{ item.commProject }} &bull; WR#{{ item.warrantyProject }}</p>
                            @if (getProjectDetailLine(item); as detailLine) {
                                <p class="project-specs">{{ detailLine }}</p>
                            }
                            <div class="project-members">
                                <i [class]="item.isFavourite ? 'ri-star-fill star-icon star-filled' : 'ri-star-line star-icon'"
                                    (click)="$event.stopPropagation(); toggleFavourite(item)"></i>
                                @if (item.userRoleName === 'Admin') {
                                    <i class="ri-vip-crown-fill crown-icon"></i>
                                }
                                <button
                                    type="button"
                                    class="project-members-btn"
                                    (click)="$event.stopPropagation(); showProjectUsersModal(item.projectId || 0, item.projectName)">
                                    <i class="ri-group-line"></i>
                                    <span class="project-members-count">{{ item.userCount || 0 }}</span>
                                </button>
                                <!-- @if (item.projectId && isBackupInProgress(item.projectId)) {
                                    <i class="ri-hourglass-fill backup-icon backup-icon--progress"
                                       [pTooltip]="getBackupTooltip(item.projectId)"
                                       tooltipPosition="top"
                                       (click)="$event.stopPropagation()"></i>
                                } -->
                            </div>
                        </div>
                    </article>
                }
            } @else {
                <div class="empty-state">
                    <i class="ri-briefcase-line"></i>
                    <p>No projects available</p>
                </div>
            }
        }

        @if (activeTab === 'all') {
            @if (filteredProjectList.length > 0) {
                @for (item of filteredProjectList; track item.projectId) {
                    <article
                        class="project-card"
                        [ngClass]="getProjectStatusLineClass(item)"
                        [title]="getProjectStatusIndicatorLabel(item)"
                        (click)="navigateToProject(item)">
                        <div class="project-card-top">
                            <div class="project-card-title">
                                <h2>{{ item.projectName }}</h2>
                            </div>
                            <div class="project-card-actions">
                                @if (canShowProjectActionMenu(item)) {
                                    <button
                                        type="button"
                                        class="card-menu-btn"
                                        (click)="item.projectId && openProjectMenu($event, item.projectId)">
                                        <i class="ri-more-2-line"></i>
                                    </button>
                                }
                            </div>
                        </div>
                        <div class="project-card-body">
                            <p class="project-ids">EQ#{{ item.projectNumber }} &bull; CX#{{ item.commProject }} &bull; WR#{{ item.warrantyProject }}</p>
                            @if (getProjectDetailLine(item); as detailLine) {
                                <p class="project-specs">{{ detailLine }}</p>
                            }
                            <div class="project-members">
                                <button
                                    type="button"
                                    class="project-members-btn"
                                    (click)="$event.stopPropagation(); showProjectUsersModal(item.projectId || 0, item.projectName)">
                                    <i class="ri-group-line"></i>
                                    <span class="project-members-count">{{ item.userCount || 0 }}</span>
                                </button>
                                <!-- @if (item.projectId && isBackupInProgress(item.projectId)) {
                                    <i class="ri-hourglass-fill backup-icon backup-icon--progress"
                                       [pTooltip]="getBackupTooltip(item.projectId)"
                                       tooltipPosition="top"
                                       (click)="$event.stopPropagation()"></i>
                                } -->
                            </div>
                        </div>
                    </article>
                }
            } @else {
                <div class="empty-state">
                    <i class="ri-briefcase-line"></i>
                    <p>No projects available</p>
                </div>
            }
        }

        @if (activeTab === 'archived') {
            @if (filteredArchivedProjects.length > 0) {
                @for (item of filteredArchivedProjects; track item.projectId) {
                    <article
                        class="project-card project-card--archived"
                        [ngClass]="getProjectStatusLineClass(item)"
                        [title]="getProjectStatusIndicatorLabel(item)"
                        (click)="navigateToProject(item)">
                        <div class="project-card-top">
                            <div class="project-card-title">
                                <h2>{{ item.projectName }}</h2>
                            </div>
                            <div class="project-card-actions">
                                @if (canShowProjectActionMenu(item)) {
                                    <button
                                        type="button"
                                        class="card-menu-btn"
                                        (click)="item.projectId && openProjectMenu($event, item.projectId)">
                                        <i class="ri-more-2-line"></i>
                                    </button>
                                }
                            </div>
                        </div>
                        <div class="project-card-body">
                            <p class="project-ids">EQ#{{ item.projectNumber }} &bull; CX#{{ item.commProject }} &bull; WR#{{ item.warrantyProject }}</p>
                            @if (getProjectDetailLine(item); as detailLine) {
                                <p class="project-specs">{{ detailLine }}</p>
                            }
                            <div class="project-members">
                                <button
                                    type="button"
                                    class="project-members-btn"
                                    (click)="$event.stopPropagation(); showProjectUsersModal(item.projectId || 0, item.projectName)">
                                    <i class="ri-group-line"></i>
                                    <span class="project-members-count">{{ item.userCount || 0 }}</span>
                                </button>
                                <!-- @if (item.projectId && isBackupInProgress(item.projectId)) {
                                    <i class="ri-hourglass-fill backup-icon backup-icon--progress"
                                       [pTooltip]="getBackupTooltip(item.projectId)"
                                       tooltipPosition="top"
                                       (click)="$event.stopPropagation()"></i>
                                } -->
                            </div>
                        </div>
                    </article>
                }
            } @else {
                <div class="empty-state">
                    <i class="ri-inbox-archive-line"></i>
                    <p>No archived projects</p>
                </div>
            }
        }
    </div>

    <p-menu #projectMenu [model]="projectMenuItems" [popup]="true" appendTo="body" styleClass="project-card-menu"></p-menu>
</section>
